export default __webpack_public_path__ + "static/media/fried_egg.7608d604.png";